import { Component, Input, OnInit } from '@angular/core';
import { WikiService } from '../services/wiki.service';
import { UiService } from '../../../core/services/core.ui.service';
import { GfTranslateService } from '../../../core/services/core.translate.service';

@Component({
  selector: 'wiki-delete-modal',
  template: require('./wiki.delete.modal.component.html'),
})
export class WikiDeleteModalComponent implements OnInit {
  @Input() wiki: any;
  @Input() project: any;
  @Input() onDelete: Function;
  @Input() onClose: Function;

  public orphanPages: any[] = [];
  public loadingOrphans: boolean = true;

  constructor(
    private wikiService: WikiService,
    private uiService: UiService,
    private translateService: GfTranslateService
  ) {}

  ngOnInit(): void {
    this.loadingOrphans = true;
    this.wikiService.getOrphanCandidates(this.wiki.id)
      .then((response: any) => {
        this.orphanPages = (response && response.items) || [];
      })
      .catch((error) => {
        console.error('Failed to load orphan candidates:', error);
        this.orphanPages = [];
      })
      .finally(() => {
        this.loadingOrphans = false;
      });
  } 

  doCancel(): void {
    this.onClose();
  }

  doDelete(): void {
    this.wikiService.deleteWiki(this.wiki.id)
      .then(() => {
        this.uiService.message.showSuccess(
          this.translateService.translate('Wiki page "{{pagename}}" has been deleted successfully.', 
            { pagename: this.wiki.pagename }
          )
        );
        this.onDelete(this.wiki);
      })
      .catch((error) => {
        console.error('Error deleting wiki page:', error);
        this.uiService.message.showError(
          this.translateService.translate('Failed to delete wiki page "{{pagename}}".', 
            { pagename: this.wiki.pagename }
          )
        );
      })
      .finally(() => {
        this.onClose();
      });
  }
}